import { SortUtility } from "../utils/sort";

type Model = {
    isUser: boolean;
    member: {
        ObjectId: number;
        Name: string;
    };
};

export const compareMembersByName = (left: Model, right: Model) => {
    return SortUtility.sortWithLocalCompare(left.member.Name, right.member.Name);
};

export const compareWithCurrentUser = (left: Model, right: Model) => {
    return compareWithCurrentUserById(left.isUser && left.member.ObjectId, right.isUser && right.member.ObjectId);
};

export const compareWithCurrentUserById = (leftId: number, rightId: number) => {
    if (leftId === ep.settings.currentUserId) {
        return -1; // MOVE CURRENT USER UP
    }
    if (rightId === ep.settings.currentUserId) {
        return 1; // MOVE CURRENT USER UP
    }
    return 0; // NOTHING CHANGE IN ORDER
};
